import React from "react";
import classNames from "../../utils/classNames";

// Controlled segmented control for picking one of a small set of options,
// e.g. a list filter. `options` is an array of { value, text }.
const SegmentedSwitch = ({ options, selected, onChange }) => {
  return (
    <div className="text-sm border-2 border-gray-100 dark:border-gray-700 rounded-md w-fit overflow-hidden flex">
      {options.map((option) => {
        const isSelected = option.value === selected;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={isSelected}
            className={classNames(
              "flex-1 py-1 px-3 whitespace-nowrap",
              isSelected
                ? "bg-white dark:bg-gray-700 text-gray-600 dark:text-gray-100 font-semibold"
                : "bg-gray-50 dark:bg-gray-800 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-white/[0.06] hover:text-gray-800 dark:hover:text-gray-200 transition-colors duration-200"
            )}
            onClick={() => onChange(option.value)}
          >
            {option.text}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedSwitch;
